const FAVICON_MAP = {
  clear: "sun.ico",
  "partly-cloudy": "cloudy.ico",
  cloudy: "cloudy.ico",
  rain: "rain.ico",
  snow: "snow.ico",
  sleet: "snow.ico",
  fog: "fog.ico",
  thunderstorm: "storm.ico",
  wind: "wind.ico",
};

const NIGHT_FAVICON = "clear-night.ico";

export function setWeatherFavicon(weather, timeOfDay) {
  const safeWeather = String(weather || "").toLowerCase();
  const safeTime = String(timeOfDay || "").toLowerCase();

  let icon = FAVICON_MAP[safeWeather] || "sun.ico";

  if (safeTime === "night" && safeWeather === "clear") {
    icon = NIGHT_FAVICON;
  }

  const faviconPath = `/weather-favicons/${icon}`;

  let link = document.querySelector("link[rel='icon']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.href = faviconPath;
}